import script from "./AuthModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthModal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__